module.exports = __webpack_public_path__ + "media/packs/images/flags/NU-0e169d316918c76230d925ef36de8a55.png";